import { configureStore } from '@reduxjs/toolkit';
import { thunk } from 'redux-thunk';
import storage from 'redux-persist/lib/storage';
import autoMergeLevel1 from 'redux-persist/lib/stateReconciler/autoMergeLevel1';
import {
  FLUSH,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
  REHYDRATE,
  persistReducer,
  persistStore,
} from 'redux-persist';
import rootReducer from './rootReducer';

const persistConfig = {
  key: 'root',
  storage,
  stateReconciler: autoMergeLevel1,
  whitelist: ['auth', 'toast', 'changeState', 'role', 'profile'],
  blacklist: [],
  debug: true,
};

const middleware = (getDefaultMiddleware) =>
  getDefaultMiddleware({
    immutableCheck: false,
    serializableCheck: {
      ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
    },
  }).concat(thunk);

const store = configureStore({
  reducer: persistReducer(persistConfig, rootReducer()),
  middleware,
  devTools: true,
});

const persister = persistStore(store);

export { store, persister };
